import { createAction } from 'redux-actions';

const actions = {
  /**
   * [1:1 문의] 1:1 문의 데이터 변경하기
   */
  SET_DATA: 'cs/inquiry/SET_DATA',
  setData: createAction('cs/inquiry/SET_DATA'),

  /**
   * [1:1 문의 리스트] 1:1 문의 리스트 요청하기
   */
  GET_INQUIRY_LIST_REQUEST: 'cs/inquiry/GET_INQUIRY_LIST_REQUEST',
  GET_INQUIRY_LIST_SUCCESS: 'cs/inquiry/GET_INQUIRY_LIST_SUCCESS',
  getCsInquiryList: createAction('cs/inquiry/GET_INQUIRY_LIST_REQUEST'),

  /**
   * [1:1 문의 리스트] 1:1 문의 리스트 excel 다운로드 요청하기
   */
  GET_INQUIRY_EXCEL_DOWNLOAD_REQUEST: 'cs/inquiry/GET_INQUIRY_EXCEL_DOWNLOAD_REQUEST',
  getInquiryExcelDownload: createAction('cs/inquiry/GET_INQUIRY_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * [1:1 문의 상세] 1:1 문의 상세 요청하기
   */
  GET_INQUIRY_DETAIL_REQUEST: 'cs/inquiry/GET_INQUIRY_DETAIL_REQUEST',
  GET_INQUIRY_DETAIL_SUCCESS: 'cs/inquiry/GET_INQUIRY_DETAIL_SUCCESS',
  getCsInquiryDetail: createAction('cs/inquiry/GET_INQUIRY_DETAIL_REQUEST'),

  /**
   * [1:1 문의 상세] 유저의 다른 문의 내역 조회하기
   */
  GET_USERS_OTHER_INQUIRY_LIST_REQUEST: 'cs/inquiry/GET_USERS_OTHER_INQUIRY_LIST_REQUEST',
  GET_USERS_OTHER_INQUIRY_LIST_SUCCESS: 'cs/inquiry/GET_USERS_OTHER_INQUIRY_LIST_SUCCESS',
  getCsUsersOtherInquiryList: createAction('cs/inquiry/GET_USERS_OTHER_INQUIRY_LIST_REQUEST'),

  /**
   * [1:1 문의 상세] 1:1 문의 답변 작성하기
   */
  REPLY_INQUIRY_DETAIL_REQUEST: 'cs/inquiry/REPLY_INQUIRY_DETAIL_REQUEST',
  REPLY_INQUIRY_DETAIL_SUCCESS: 'cs/inquiry/REPLY_INQUIRY_DETAIL_SUCCESS',
  replyCsInquiryDetail: createAction('cs/inquiry/REPLY_INQUIRY_DETAIL_REQUEST'),

  /**
   * [1:1 문의] 질문 내용 모달 토글
   */
  TOGGLE_MODAL: 'cs/inquiry/TOGGLE_MODAL',
  toggleModal: createAction('cs/inquiry/TOGGLE_MODAL'),
};

export default actions;
